import React,{ useState, useEffect} from 'react'

import  {useToast} from "@chakra-ui/react";
import axios from "axios";
import EnvRoute from '../middleware/envRoute';
import {AppState} from '../context/AppProvider';

import LoginLogo from './loginLogo';
// import Passage from "@passageidentity/passage-node";
import "@passageidentity/passage-auth";

const copy ="a dynamic place to meet"
  const OM_API = `https://open-mic-api.onrender.app/api`
  const TC_API = 'https://tin-can-api.onrender.app/api'
  
  const OM_API_LOC = `http://localhost:5001/api`
  const TC_API_LOC = 'http://localhost:5002/api'

  const OM_CHK =  `${OM_API}/user/status`//!---change to OM_API
  const TC_CHK =  `${TC_API}/user/status`

  const OM_REG =  `${OM_API}/user/reg`
  const TC_REG =  `${TC_API}/user`

const ENV_ENDPOINT = EnvRoute('prod'); 


 function Login(props) {
    const [ email , setEmail ] = useState('');
    const [ password , setPassword ] = useState('');
    const [ show, setShow ] = useState(false)
    const [ loading , setLoading ] = useState(false)
    const [ actionError , setActionError ] = useState('')

    // const toast = useToast();

    const {isLoggedIn, 
        setIsLoggedIn,
        view,
        setView,
        room,
        setRoom,
        user,
        setUser,
        OM_user, 
        setOM_user,
        TC_user, 
        setTC_user} = AppState()

   const linkageCheck = async (URI,ABRV) =>{

    /*------
    Make a call to openMic Api to see if this users email has an account
    if not:
    ----------- */
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      // const { data } = await axios.post( URI, { email:email,linkage:true }, config);
      const { data } = await axios.post( `${URI}/user/login`, { email:email,linkage:true }, config);
      
      if (data)
      {
        if ( ABRV === 'OM' ){
          console.log('[OM_USER_INFO]:',data);
          setOM_user(data)
          localStorage.setItem("OM_user", JSON.stringify(data));
          }else if ( ABRV === 'TC' ){
            console.log('[TC_USER_INFO]:',data);
            setTC_user(data)
          }else{setActionError('Linkage Error: No API Reference')}
      }else{
        if ( ABRV === 'OM' ){OMLinkageSubmit(OM_REG)}
        else if ( ABRV === 'TC' ){TCLinkageSubmit(TC_REG)}
        else{setActionError('Linkage Error: No API Reference')}
      }
    } catch (error) {
      console.log((ABRV === 'OM')?'OpenMic':'TinCan',' registration failure:', error)
      setActionError(((ABRV === 'OM')?'OpenMic':'TinCan','Linkage Error Occured'))
    }
    
  }
  const OMLinkageSubmit = async (URI) =>{
    /*------
      Make a call to openMic Api to see if this users email has an account
      if not:
    */
  
   try {
     const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.post(URI,
        {...user},
        config
      );
      console.log('[OM_USER_INFO]:',data);
      // set_OM_id(data?._id)
      setOM_user(data)
    } catch (error) {
      console.log('OpenMic registration failure:', error)
      setActionError('Error occured')

    }
    
  }
  const TCLinkageSubmit = async (URI) =>{
    /*------
      Make a call to openMic Api to see if this users email has an account
      if not:
    */
  
   try {
     const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.post(URI,
        {
        ...user},
        config
      );
      console.log('[TC_USER_INFO]:',data);
      // set_TC_id(data?._id)
      setTC_user(data)
    } catch (error) {
      console.log('TinCan registration failure:', error)
      setActionError('Error occured')
    }
    
  }

    const handleShowClicK = (e) => {
      e.preventDefault()
       setShow(!show)
      }

    const handleLogin = async (e) => {
        e.preventDefault()
         setLoading(true);
    if ( !email || !password ) {
        setActionError('Please Fill all the Feilds')
        // alert('Please Fill all the Feilds')
        setLoading(false);
      return;
    }
   else{

       try {
         const config = {
           headers: {
             "Content-type": "application/json",
           },
         };
         // setIsOnline(true)
         const { data } = await axios.post(
           `${ENV_ENDPOINT}/api/user/login`,
           {
             email,
             password,
           },
           config
         );
   
           setUser(data)
         console.log("[login] user:",data);
         localStorage.setItem("TH_user", JSON.stringify(data));
         //  axios.put(
             //   `${ENV_ENDPOINT}/api/user/update`,
             //   {...data},
             //   config
             // );
             try{
                 setUser(JSON.parse(localStorage.getItem("TH_user")));
                 console.log('[login] user:', user)
                 linkageCheck(OM_API_LOC, 'OM')
                linkageCheck(TC_API_LOC, 'TC')
                 setLoading(false);
                 setIsLoggedIn(true)
                 setView('hub')
                 window.location.href = '/hub'
                } catch (error){
                 console.log(error)
                 setActionError('Please check email and/or password')

             }
           // history.push("/chats");
           // refreshPage()
         } catch (error) {
           console.log(error)
           setActionError('Error')
          //  setActionError(error.message)
           setIsLoggedIn(false)
         setLoading(false);
       }
   }
        


    }
    return (
        <div>
        
        
            {/* <h1 className="view-header ">Login</h1> */}
            {/* <div className="login-wrap" id="login-wrap"> */}
               <form className="space-y-6" action="#" method="POST">
                    <div className="flex items-center justify-between">
                        <label style={{color:'#fff'}} htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                            email:
                        </label>
                    </div>

                    <div className="mt-2">
                        <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        onChange={(e)=>setEmail(e.target.value.toLowerCase())}
                            value ={email}
                        required
                        // className="block w-full rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>

                    <div className="flex items-center justify-between">
                        <label style={{color:'#fff'}} htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                            password:  <button className="login-button" h="1.75rem" size="sm"  onClick={(e)=>handleShowClicK(e)} >
                        {show ? "hide" : "show"}
                        </button>
                        </label>
                    </div>
                    <div className="mt-2" >
                        {/* style={{display:'flex', flexDirection:'row', width:'100%'}}> */}
                        <input  
                            id="password"
                            name="password"
                            autoComplete='password'
                            type={show ?'text':'password'}
                            placeholder='enter password'
                            onChange={(e)=>setPassword(e.target.value)}
                            className="block w-full rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            required

                            // border={'1px solid #868686'}
                            // color={'#868686'}
                            />
                       
                    </div>
                    <div className={loading?'blink':''}>
                        <button
                            type="submit"
                            //!add blink
                            // className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            className={actionError ? 'error-button' : 'login-button'}
                            id="login-button"
                            style={{padding:'.5rem', marginTop:'1rem'}}
                            onClick={handleLogin}
                            //  isLoading= {loading}
                        >
                            {loading? "signing":"sign"} in
                        </button>
                    </div>

                </form>
                <h3 style={{color:"red"}}>{actionError?actionError:''}</h3>
                {/* <passage-auth 
                app-id={process.env.REACT_APP_PASSAGE_APP_ID}
                ></passage-auth> */}
                
            {/* </div> */}
        </div>
  );
}
export default Login; 